import { loadableWithFallback } from '@vision/ui/utils';
import type { PieChart2Props } from './PieChart2';

export const PieChart2 = loadableWithFallback<PieChart2Props>(() => import('./PieChart2'));
